import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import TutorProfile from './pages/TutorProfile';
import Register from './pages/Register';
import AddTutor from './pages/AddTutor';
import Dashboard from './pages/Dashboard';
import EditProfile from './pages/EditProfile';
import Login from './pages/Login';
import { initGA, trackPageView } from './utils/analytics';

// Component to track page views on route change
function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
}

function App() {
  useEffect(() => {
    // Initialize GA once when app loads
    initGA();
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <AnalyticsTracker />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/tutor/:id" element={<TutorProfile />} />
              <Route path="/specialist/:slug" element={<TutorProfile />} />
              <Route path="/register" element={<Register />} />
              <Route path="/add-tutor" element={<AddTutor />} />
              <Route path="/login" element={<Login />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/edit-profile" element={<EditProfile />} />
            </Routes>
          </main>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
